import { GatewayPaymentProfile } from './gateway-payment-profile.model';

export class GatewayCustomerProfile {
  public CcCustomerProfileId: number;
  public ProfileId: number;
  public Email: string;
  public GatewayType: number;
  public PaymentProfiles: Array<GatewayPaymentProfile>;
}
